import React from "react";
import NumberFormat from "react-number-format";

/*

InputProps={{
          inputComponent: CurrencyInput,
        }}

*/

interface CurrencyInputProps {
  inputRef: (element: HTMLInputElement | null) => void;
  onChange: (event: { target: { value: string } }) => void;
  [key: string]: any;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  inputRef,
  onChange,
  ...other
}) => {
  return (
    <NumberFormat
      type={"tel"}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={0}
      isNumericString
      prefix="$"
      {...other}
    />
  );
};

export default CurrencyInput;
